export const integrationsUrl = 'notifications/integrations/';
export const integrationLogsUrl = (integrationId: string) => `notifications/integrations/${integrationId}/logs/`;
